import React, { useContext, useEffect } from "react";
import style from "./index.module.scss";
import { useAtom } from "jotai";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "antd";
import { useSearchParam } from "react-use";
import TableList from "./Components/TableList";
import {
    filteredList,
    groupStaticsListAtom,
    statusFilterAtom
} from "../../store";
import DetailLayout from "../../../components/DetailLayout";
import CourseHeader from "../../../components/CourseHeader";
import { CourseContext } from "../../../Store";
import Buttons from "./Components/Buttons";
import { useAtomValue } from "jotai";

export default function GroupsList() {
    const history = useHistory();
    const { activityId } = useParams();
    const { basename } = useContext(CourseContext);
    // 筛选后的列表数据
    const [filter, setFilter] = useAtom(statusFilterAtom);
    const data = useAtomValue(groupStaticsListAtom);
    const groupStaticsList = useAtomValue(filteredList);

    const status = useSearchParam("status") || "all"; // 默认过滤状态

    useEffect(() => {
        setFilter({ status: status, text: "" });
    }, [status]);

    return (
        <DetailLayout breadcrumb="小组详情">
            <CourseHeader
                title={data?.activity.activityName || ""}
                info={
                    <div className={style.info}>
                        截止时间：{data?.activity.deadlineStr}
                    </div>
                }
                extra={
                    <Button
                        type="link"
                        className={style.link}
                        onClick={() =>
                            history.replace(
                                `${basename}/group/detail/${activityId}/members`
                            )
                        }>
                        <img src={require("./img/icon.png")} />
                        查看小组成员得分
                    </Button>
                }
            />

            <Buttons
                filterObj={filter}
                onChange={setFilter}
                allCounts={data?.totalGroupCount || 0}
                judgeCounts={data?.hasCorrectedCount || 0}
                noJudgeCounts={data?.notCorrectedCount || 0}
                noJoinInCounts={data?.notPartInCount || 0}
            />

            <TableList list={groupStaticsList || []} />
        </DetailLayout>
    );
}
